var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2018 0H30.1084L19.3887 12.2262L32 28.8627H22.1251L14.3913 18.7725L5.54181 28.8627H0.631813L12.0977 15.7857L0 0H10.1249L17.1159 9.22263L25.2018 0ZM23.4796 25.9319H26.1986L8.64769 2.77695H5.73019L23.4796 25.9319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter1);
export default __webpack_public_path__ + "static/media/twitter1.da7a3d33ae8b39da00d0ae6a19d25c69.svg";
export { ForwardRef as ReactComponent };